import React from 'react';
import { Button } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StyledLink from '../../../../Layout/StyledLink';

const FlaggedAddClientActivityBtn = ({ clearAction, merchantFlags: flags }) => {

  const clientActivityEnabled = flags?.client_activity?.enabled;

  if (clientActivityEnabled) {
    return (
      <StyledLink to="/Configuration/client-activity/add-client-activity">
        <Button id="AddClientActivityButton" type="primary" onClick={clearAction}>
          <FontAwesomeIcon
            style={{ width: '14px', height: '14px', marginBottom: '0px' }}
            icon={['far', 'list']}
            className="m-right-8"
            size="1x"
          />{' '}
          Add Client Activity
        </Button>
      </StyledLink>
    );
  }
  return null;
};
export default FlaggedAddClientActivityBtn;
